import React, { FC, AriaAttributes, DetailedHTMLProps } from 'react';
import { ProgressWrapper, Progress, ProgressInner, ProgressIndicator } from './ProgressBar.styles';
import { Props } from '@sleepunique/types/progress-bar-type';

const ProgressBar: FC<Props & DetailedHTMLProps<AriaAttributes, HTMLInputElement>> = ({ max, value }) => {
  const percentage = Math.min(100, Math.round((value / max) * 100));
  const percentageDisplay = max === value ? 'complete' : `${Math.min(100, Math.round((value / max) * 100))}%`;

  return (
    <ProgressWrapper role="progressbar" aria-valuemin={0} aria-valuemax={100}>
      <Progress>
        <ProgressInner style={{ width: `${percentage}%` }} />
      </Progress>
      <ProgressIndicator>{percentageDisplay}</ProgressIndicator>
    </ProgressWrapper>
  );
};

export default ProgressBar;
